import React from "react";
import { gql } from "@apollo/client";

import { List } from "@mui/material";
import { EarHearing as SoundShapingIcon } from "mdi-material-ui";

import SidebarItem from "./SidebarItem";
import SoundShapingListItem from "./soundShaping/SoundShapingListItem";

export default function OrderSidebarSoundShaping({ order }) {
  return (
    <SidebarItem
      icon={<SoundShapingIcon />}
      title="Sound shapings"
      unmountOnExit
    >
      <List disablePadding>
        {order.soundShapings.map((soundShaping, idx) => (
          <SoundShapingListItem
            key={soundShaping.id}
            order={order}
            soundShaping={soundShaping}
            count={order.soundShapings.length - idx}
          />
        ))}
      </List>
    </SidebarItem>
  );
}

OrderSidebarSoundShaping.fragments = {
  order: gql`
    fragment Orders_OrderSidebarSoundShaping_Order on Order {
      id

      soundShapings {
        id

        ...OrderSidebar_SoundShaping_ListItem_soundShaping
      }

      ...OrderSidebar_SoundShaping_ListItem_order
    }

    ${SoundShapingListItem.fragments.order}
    ${SoundShapingListItem.fragments.soundShaping}
  `,
};
